import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-aslsyllabus',
    templateUrl: './aslsyllabus.component.html',
    styleUrls: ['./aslsyllabus.component.scss']
})
export class AslsyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
